export enum AuditTypes {
    Unchanged = 0,
    Insert = 1,
    Update = 2,
    Delete = 3,
    Read = 4
}